module.exports = __webpack_public_path__ + "static/joey-accardo-3c2c4d43651218e8ed0b2b0d299d0df2.jpeg";